export const NOTIFICATION_BADGE_VARIANT = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const
